/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.75 0H11v13h13v-.75C24 5.4845 18.5155 0 11.75 0Zm.75 11.5V1.5258a10.686 10.686 0 0 1 3.8612 1.0106l-.3785.6553a.7494.7494 0 0 0 .2745 1.024.7507.7507 0 0 0 1.0245-.2744l.3857-.6675a10.8102 10.8102 0 0 1 2.8788 2.7949l-.7197.4152c-.3587.207-.4821.6658-.275 1.0244a.7501.7501 0 0 0 1.0239.2747l.7466-.4308A10.686 10.686 0 0 1 22.4742 11.5H12.5ZM7.5 19.7963a.7503.7503 0 0 0-1.0235.2727l-.001.0017-.7497 1.2978-.0573.1233a.7502.7502 0 0 0 1.355.6287l.001-.0018.7497-1.2978.0573-.1233a.7497.7497 0 0 0-.3315-.9013ZM6.7246 21.08a.703.703 0 0 0 .0246.0149l.0118.0067a.6852.6852 0 0 0 .0144.0078.7101.7101 0 0 0-.0395-.0232c-.0038-.0022-.0077-.0042-.0113-.0062ZM16.9755 22.1187c.2072.3581.666.4813 1.0245.2744a.7494.7494 0 0 0 .2745-1.024l-.75-1.2984c-.2072-.3581-.666-.4813-1.0245-.2744a.7494.7494 0 0 0-.2745 1.024l.75 1.2984Zm.2748-1.0248-.0102.006-.0154.0095a.8776.8776 0 0 0 .025-.0139l.0006-.0016Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M21.3678 18.2774c.3586.2065.8175.084 1.0245-.2744a.7494.7494 0 0 0-.2745-1.024l-1.2991-.7496c-.3586-.2066-.8175-.084-1.0245.2743a.7495.7495 0 0 0 .2745 1.0241l1.2991.7496ZM3.1831 16.2283a.7502.7502 0 0 1 1.0227.2754.7496.7496 0 0 1-.1638.9462l-.1107.0779-1.299.7496-.002.0011a.7502.7502 0 0 1-1.0226-.2755.7496.7496 0 0 1 .1638-.9462l.1107-.0778 1.301-.7507ZM2.25 12.7556c.4142 0 .75-.3356.75-.7496a.7498.7498 0 0 0-.75-.7496H.75a.7498.7498 0 0 0-.75.7496c0 .414.3358.7496.75.7496h1.5ZM1.8828 7.0333c-.3587-.207-.4822-.6658-.2751-1.0243a.7502.7502 0 0 1 1.024-.2747l1.299.7496c.3587.207.4822.6658.275 1.0244a.7502.7502 0 0 1-1.0239.2746l-1.299-.7496Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.4755 3.9413c.2072.358.666.4813 1.0245.2744a.7494.7494 0 0 0 .2745-1.024l-.75-1.2984C6.8173 1.5352 6.3585 1.412 6 1.6189a.7494.7494 0 0 0-.2745 1.024l.75 1.2984Zm.2748-1.0248a.8377.8377 0 0 0-.0257.0154.7714.7714 0 0 0 .0251-.0138l.0006-.0016Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12.75 21.7511a.7498.7498 0 0 0-.75-.7496.7498.7498 0 0 0-.75.7496v1.4993c0 .414.3358.7496.75.7496s.75-.3356.75-.7496v-1.4993Z"
    />
  </React.Fragment>,
  'Period'
);
